/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Clients_None_SelectedInputs */

const en_users_form_clients_none_selected = /** @type {(inputs: Users_Form_Clients_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No client selected`)
};

const pt_br2_users_form_clients_none_selected = /** @type {(inputs: Users_Form_Clients_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum cliente selecionado`)
};

/**
* | output |
* | --- |
* | "No client selected" |
*
* @param {Users_Form_Clients_None_SelectedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_none_selected = /** @type {((inputs?: Users_Form_Clients_None_SelectedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_None_SelectedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_none_selected(inputs)
	return pt_br2_users_form_clients_none_selected(inputs)
});